import { useMutation } from '@tanstack/react-query';
import { IImpersonationContext, IOperationResultNoValue, ImpersonationBroker } from '../../extViewmodels';
import { WebsiteContent } from '../../extViewmodels/sdk/models/Website';
import { useUserSession } from '../../models/hooks/appStateHooks';

export function useCreateWebsiteContentMutation<T extends WebsiteContent = WebsiteContent>({
	onSuccess,
	onError,
}: {
	onSuccess?: (data: WebsiteContent) => void;
	onError?: (error: IOperationResultNoValue) => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: (params: { id: string; content: Omit<T, 'id'>; impersonationContext?: IImpersonationContext }) => {
			return userSession.webServiceHelper.callAsync<WebsiteContent>(
				ImpersonationBroker.composeApiUrl({
					urlPath: `website/${params.id}/content`,
					impersonationContext: params.impersonationContext,
				}),
				'POST',
				params.content
			);
		},
		onError,
		onSuccess,
	});
}
